/**
 * Pastel palette for appointment labels (GDN-2019).
 *
 * Deliberately a SEPARATE, muted palette from the encounter-type `colorN` colors
 * used for event-block rings/dots — so a label's color reads as a secondary signal
 * and does not clash with the dominant encounter-type ring. Token names mirror the
 * Linear-style picker (gray/blue/teal/green/yellow/orange/pink/red/purple).
 */

export const LABEL_PASTEL_COLORS: Record<string, string> = {
  gray: '#C7CCD1',
  blue: '#AEC6F5',
  teal: '#A8DBD6',
  green: '#BCE0B6',
  yellow: '#F2E2A6',
  orange: '#F5C9A0',
  pink: '#EBC2D4',
  red: '#F2B5B0',
  purple: '#CFC0EE',
};

export const DEFAULT_LABEL_COLOR_TOKEN = 'gray';

/** Ordered token list for the color picker. */
export const LABEL_COLOR_TOKENS = Object.keys(LABEL_PASTEL_COLORS);

/** Resolve a label color token to its hex, falling back to the default. */
export const getLabelColor = (token?: string | null): string =>
  (token && LABEL_PASTEL_COLORS[token]) || LABEL_PASTEL_COLORS[DEFAULT_LABEL_COLOR_TOKEN];
